import { lazyRenderWidgetByLoader } from 'core-components/helpers/lazyLoad'
import { GP360Application } from 'partner360/containers/gp360Application/GP360Application'
import { P360Application } from 'partner360/containers/p360Application/P360Application'

import { P360PartnerSettings, PartnerSettings } from './public/partner360/P360PartnerSettings'

export const WidgetSelectorPartner360 = (props: any) => {
  if (props.viewModel === 'jbp-elt-tracker') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/features/eltTracker'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-business-priorities') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/features/businessPriorities/ui/businessPriorities/BusinessPriorities'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-market-yoy-growth') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'partner360/features/marketYoyGrowthExpectation/ui/views/marketYoyGrowthExpectation/MarketYoyGrowthExpectation'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-welcome-flow') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/features/welcomeFlow/ui/welcomeFlow/WelcomeFlow'),
      props: props.props,
    })
  }

  if (props.viewModel === 'api-monitoring-panel') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/apiMonitoringPanel/ApiMonitoringPanel'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-basic-info-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/partnerBasicInfoRedesigned/PartnerBasicInfo'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-share-of-business') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/shareOfBusiness/SoBWrapper'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-device-info-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/devicesInfo/partnerDevicesInfo/PartnerDevicesInfo'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-market-info-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/marketInfo/partnerMarketInfo/PartnerMarketInfo'),
      props: props.props,
    })
  }

  if (props.viewModel === 'programs-management-admin-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/ProgramsManagementAdmin'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partnersearchv2-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/searchForm/SearchForm'),
      props: { ...props.props, isCompletenessVisible: true },
    })
  }

  if (props.viewModel === 'searchresult-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/searchResult/SearchResults'),
      props: { ...props.props, isPartner360: true },
    })
  }

  if (props.viewModel === 'partner-base-metrics-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/devicesInfo/partnerBaseMetrics/PartnerBaseMetrics'),
      props: props.props,
    })
  }

  if (props.viewModel === 'top-vendor-brands-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/devicesInfo/topVendorBrands/TopVendorBrands'),
      props: props.props,
    })
  }

  if (props.viewModel === 'vertical-market-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/widgets/marketInfo/partnerVerticalMarket/PartnerVerticalMarket'),
      props: props.props,
    })
  }

  if (props.viewModel === 'hp-solutions-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/PartnerSolutions'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-contact-info-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/PartnerContactInfo'),
      props: props.props,
    })
  }

  if (props.viewModel === 'сompensation-scheme-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/Compensation'),
      props: props.props,
    })
  }

  if (props.viewModel === 'actions-plan-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/ActionsPlan'),
      props: props.props,
    })
  }

  if (props.viewModel === 'commitment-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/CommitmentWrapper'),
      props: props.props,
    })
  }

  if (props.viewModel === 'acknowledgment-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/acknowledgment'),
      props: props.props,
    })
  }

  if (props.viewModel === 'completeness-indicator-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/PartnerCompletenessWrapper'),
      props: props.props,
    })
  }

  if (props.viewModel === 'f-years-selector') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/fYearSelector/FYearsSelector'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-manager-dashboard') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/reports/managerDashboard/ManagerDashboard'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'completeness-report-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/reports/Reports'),
      props: props.props,
    })
  }

  if (props.viewModel === 'completeness-sob-report-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/SoBReportDownload/SoBReportDownload'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-contact-table-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/features/contacts/ui/contactsTable/ContactsTable'),
      props: props.props,
    })
  }

  if (props.viewModel === 'parnter-financial-offering-leasing-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/marketInfo/partnerLeasing/PartnerLeasing'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-historical-results-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/PartnerHistoricalResults'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-daas-summary') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/DaasSummary'),
      props: props.props,
    })
  }

  if (props.viewModel === 'hp-contacts-table') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/hpContactsTable/HPContactsTable'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-country-top-partner-summary') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/TopPartnerSummary'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner-master-dealer-table-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/PartnerMasterDealerTable'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-mps-top-partner-summary') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/historicalResults/mps/MPSSummary'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-country-manager-summary') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/backOffice/countryManagerSummary/CountryManagerSummary'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-country-manager-summary-distributors') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/backOffice/countryManagerSummary/CountryManagerSummaryDitstributors'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-country-manager-summary-retailers') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/backOffice/countryManagerSummary/CountryManagerSummaryRetailers'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-pbm-report') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/pbmReport/PBMReport'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-master-dealer-report') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/MasterDealerReport'),
      props: props.props,
    })
  }
  if (props.viewModel === 'partner360-program-type-buttons') {
    return (
      <P360Application
        urlPartnerId={props.props.pid}
        widgetParams={props.props.widgetParams}
        metrics={props.props.metrics}
      >
        <P360PartnerSettings {...props.props} />
      </P360Application>
    )
  }
  if (props.viewModel === 'global-partner360-program-type-buttons') {
    return (
      <GP360Application
        urlPartnerId={props.props.pid}
        widgetParams={props.props.widgetParams}
        metrics={props.props.metrics}
      >
        <PartnerSettings {...props.props} />
      </GP360Application>
    )
  }
  if (props.viewModel === 'global-partner360-tabs') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/gp360Tabs/GP360Tabs'),
      props: props.props,
    })
  }
  // TODO rename model to global-partner360-details
  if (props.viewModel === 'global-partner-details') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/gp360Details/GP360Details'),
      props: props.props,
    })
  }
  if (props.viewModel === 'global-partner360-contacts-table') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/features/contacts/ui/contactsTable/ContactsTable'),
      props: props.props,
    })
  }
  if (props.viewModel === 'global-partner360-consolidated-view') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/consolidatedView/ConsolidatedView'),
      props: props.props,
    })
  }
  if (props.viewModel === 'global-partner360-partner-basic-info') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/partnerBasicInfoRedesigned/GP360PartnerBasicInfo'),
      props: props.props,
    })
  }
  if (props.viewModel === 'partner360-tabs') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/p360Tabs/P360Tabs'),
      props: props.props,
    })
  }
  if (props.viewModel === 'partner360-mifreport') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partner360/MIFReport'),
      props: props.props,
    })
  }

  if (props.viewModel === 'partner360-executive-report') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/executiveReports/ExecutiveReportTabs'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'salesTeamSelfManagement') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/salesTeamSelfManagement/SalesTeamSelfManagement'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'p360-top-partner-summary-report') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/topPartnerSummary/TopPartnerSummary'
        ),
      props: props.props,
    })
  }

  if (props.viewModel === 'p360-top-partners') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/topPartnersWidget/TopPartners'),
      props: props.props,
    })
  }

  if (props.viewModel === 'amplify-eligibility-extended') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/amplifyEligibilityExtended/AmplifyEligibilityExtended'
        ),
      props: props.props,
      loadMeta: true,
    })
  }

  if (props.viewModel === 'test-stand') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/testStand/TestStand'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-composed-report') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/composedReport/ComposedReport'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-global-partner-administration') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/gp360Administration/GP360Administration'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-sob-trends') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/sobTrends/SobTrends'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-landing-redirecting') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/landingRedirect/LandingRedirect'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-pbm-landing') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/pbmLanding/PbmLanding'),
      props: props.props,
    })
  }

  if (props.viewModel === 'qbr-document') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/components/QBR/QBR'),
      props: {
        ...props.props,
        entryId: props.props.documentId,
        preDefinedRtm: props.props.rtm,
        preDefinedPid: props.props.pid,
      },
    })
  }

  if (props.viewModel === 'jbp-h2-planning-review') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/h2PlanningReview'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-pbm-cockpit') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/pbmCockpit'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-planning-cockpit') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/features/financialCockpit').then((m) => ({
          default: m.PlanningCockpit,
          getMetaInfo: m.getMetaInfo,
        })),
      props: props.props,
      loadMeta: true,
    })
  }

  if (props.viewModel === 'jbp-manager-cockpit') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/features/financialCockpit').then((m) => ({
          default: m.ManagerPlanningCockpit,
        })),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-planning-view-switcher') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/planningViewSwitcher'),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-esp-admin-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/features/executiveSponsorProgram').then((m) => ({
          default: m.EspAdminRequestsPanel,
        })),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-esp-sponsor-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/features/executiveSponsorProgram').then((m) => ({
          default: m.EspSponsorsCard,
        })),
      props: props.props,
    })
  }

  if (props.viewModel === 'jbp-esp-dashboard') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/features/executiveSponsorProgram').then((m) => ({
          default: m.EspDashboardWidget,
        })),
      props: props.props,
    })
  }

  return null
}
